import FormCertificateFields from '../../Pages/ScheduleConecta/Components/FormFields/FormCertificateFields';
import FormFinanceFields from '../../Pages/ScheduleConecta/Components/FormFields/FormFinanceFields';
import FormGeneralFields from '../../Pages/ScheduleConecta/Components/FormFields/FormGeneralFields';
import FormLogisticFields from '../../Pages/ScheduleConecta/Components/FormFields/FormLogisticFields';
import FormTransportFields from '../../Pages/ScheduleConecta/Components/FormFields/FormTransportFields';

const GENERAL_FIELD_NAMES = [
  'Product',
  'ProductDescription',
  'Stage',
  'Date',
  'StartHour',
  'Resource',
  'MainInstructor',
  'AssistantInstructor',
  'InstructorValue',
  'AssistantInstructorValue',
  'Group',
  'QuoteTitle',
  'TrainingTransportation',
  'QuoteResponsible',
  'DealOportunity',
  'DealId',
  'DealTitle',
  'DealClient',
  'DealClientCommercialName',
  'DealContractedCompany',
  'DealTrainingCenterAdress',
  'DealPaymentCondition',
  'DealPaymentForm',
  'ObrigatoryBuyOrder',
  'DealEndDateInvoice',
  'DealTributaryRetention',
  'DealPrioritaryClient',
  'DealClientObservation',
  'DealClientNeed',
  'DealPostSale',
  'DealOfficialTrainingDates',
  'DealIndustry',
  'DealType',
  'DealPaymentFormNegotiated',
  'DealPaymentConditionNegotiated',
  'OfficialInvoiceIssue',
  'QtyClass',
  'QtyStudentsPerClass',
  'StudentsTrained',
  'StudentsTransported',
  'TrainingCenter',
  'DateScheduling',
  'InitialAttendanceList',
  'FinalAttendanceList',
  'InstructorForm',
  'DealBuyOrder',
  'DownloadDealBuyOrderOfficial2',
  'DownloadDealExtraAttachments',
  'AcceptTerm1',
  'AcceptTerm2',
  'DateUploadAcceptTerm2',
  'HasDocumentation',
  'AcceptSharedTraining',
  'AttendanceListChecked',
  'QuoteProducts',
  'DealNotes',
  'CommercialNotes',
  'LogisticsNotes',
  'FinanceNotes',
  'CtNotes',
  'InstructorNotes',
];

const LOGISTIC_FIELD_NAMES = [
  'Advance24h',
  'TransportStopAddress',
  'ReferencePoint',
  'ResponsiblePersonNameLogistic',
  'ResponsiblePersonPhoneLogistic',
  'ResponsiblePersonEmailLogistic',
  'MapLocation',
  'PostalCodeLogistic',
  'StreetLogistic',
  'NumberLogistic',
  'DistrictLogistic',
  'CityLogistic',
  'StateLogistic',
  'ComplementLogistic',
  'Refund',
  'AmountPaidTransportation',
  'ConfirmationDate',
  'ConfirmedBy',
  'NameResponsibleConfirmation',
  'EmailResponsibleConfirmation',
  'PhoneResponsibleConfirmation',
];

const TRANSPORT_FIELD_NAMES = ['TransportCompany', 'DriverList', 'BoardingHour', 'ArrivalHour'];

const FINANCE_FIELD_NAMES = [
  'TrainingValue',
  'TransportValue',
  'TrainingAndTransportValue',
  'BillingDeadlineDate',
  'ReasonNoBilling',
  'NFTransportation',
  'NFTraining',
  'InvoiceNumber',
  'InvoiceEmissionDate',
  'InvoiceIssuer',
  'TotalInvoiceValue',
  'PartialInvoiceValue',
  'QtyStudentsDiff',
  'OmieNotes',
];

const CERTIFICATE_FIELD_NAMES = ['NotHaveCertificate'];

function mapFieldNames(names, value) {
  return Object.fromEntries(names.map((fieldName) => [fieldName, value]));
}

function mapOwner(names, owner) {
  return mapFieldNames(names, owner);
}

function mapSectionKey(names, sectionKey) {
  return mapFieldNames(names, sectionKey);
}

export const TASK_FORM_PRODUCTION_SECTIONS = [
  { key: 'general', title: 'Geral' },
  { key: 'logistic', title: 'Logística' },
  { key: 'transport', title: 'Transporte' },
  { key: 'finance', title: 'Financeiro' },
  { key: 'certificate', title: 'Certificado' },
];

export const TASK_FORM_PRODUCTION_SECTION_BY_FIELD_NAME = {
  ...mapSectionKey(GENERAL_FIELD_NAMES, 'general'),
  ...mapSectionKey(LOGISTIC_FIELD_NAMES, 'logistic'),
  ...mapSectionKey(TRANSPORT_FIELD_NAMES, 'transport'),
  ...mapSectionKey(FINANCE_FIELD_NAMES, 'finance'),
  ...mapSectionKey(CERTIFICATE_FIELD_NAMES, 'certificate'),
};

export const TASK_FORM_WIDGET_OWNERS = {
  ...mapOwner(GENERAL_FIELD_NAMES, FormGeneralFields),
  ...mapOwner(LOGISTIC_FIELD_NAMES, FormLogisticFields),
  ...mapOwner(TRANSPORT_FIELD_NAMES, FormTransportFields),
  ...mapOwner(FINANCE_FIELD_NAMES, FormFinanceFields),
  ...mapOwner(CERTIFICATE_FIELD_NAMES, FormCertificateFields),
};
